<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="消息标题:">
                        <el-input v-model="formData.title" placeholder="请填写消息标题" size="medium" :maxlength="40"></el-input>
                        <small class="from-tip"><span class="el-icon-warning"></span>标题会展示给用户，请合理填写</small>
                    </el-form-item>
                </el-col> 
				<el-col :xs="24" :sm="12" :xl="8">
				    <el-form-item prop="document" label="消息内容:">
				        <el-input type="textarea" v-model="formData.document" placeholder="请填写" size="medium" :maxlength="500"></el-input>
				    </el-form-item>
				</el-col>
            </el-row>
			<el-row :gutter="40">			    
			    <el-col :xs="24" :sm="12" :xl="8">
			        <el-form-item prop="type" label="消息类型:">
			            <el-select v-model="formData.type" placeholder="请选择">
			                <el-option label="推送演出" :value="1"></el-option>
			                <el-option label="推送巡演" :value="4"></el-option>
			                <el-option label="推送众筹" :value="2"></el-option>
			                <el-option label="自定义推送" :value="3"></el-option>
			            </el-select>
			        </el-form-item>
			    </el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item v-if="formData.type !== 3" prop="pushObj" label="解析对象:" :key="`pushObj_${ukey}`">
					    <el-select 
					        v-model="formData.pushObj"
					        value-key="value" 
					        :filterable="true" 
					        :remote="true"
					        :remote-method="remote"
					        :loading="remoteLoading"
					        @change="pushObjChange"
					        placeholder="请选择(填写ID搜索)"
					        >
					        <el-option v-for="item in remoteOptions" :key="item.value" :label="item.label" :value="item"></el-option>
					    </el-select>
					    <small class="from-tip" v-if="formData.pushObj">
					        <span class="el-icon-warning"></span>
					        {{formData.pushObj.labelTips}}
					    </small>
					</el-form-item>
				</el-col>
			</el-row>
            <el-row v-if="formData.type === 3"  :gutter="40">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item label="消息封面:" :key="`imgPath_${ukey}`">
					    <image-upload 
					        :url.sync="formData.imgPath" 
					        :urlFull.sync="formData.imgPath" 
					        :crop="true"
					        :min-width="1006"
					        :min-height="660"
					        ref="posterUpload"
					        class="poster-upload"
					    >
					        <span slot="size">规格1006px*660px</span>
					    </image-upload>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item label="跳转链接:" :key="`url_${ukey}`">
					    <el-input v-model="formData.url" placeholder="请填写" size="medium" :maxlength="100"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="formData.type === 4"  :gutter="40">
				<el-col :xs="24" :xl="16">
					<el-form-item  prop="rule" label="巡演跳转规则:" :key="`rule_${ukey}`">
					    <el-select v-model="formData.rule" placeholder="请选择">
					        <el-option label="巡演所含城市的用户点击后跳转至对应演出详情页，其余城市的用户点击后跳转至巡演列表页" :value="1"></el-option>
					        <el-option label="所有用户点击后跳转至巡演列表页" :value="2"></el-option>
					    </el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="40">
				<el-col :xs="24" :sm="12" :xl="8">
				    <el-form-item prop="pushMode" label="推送方式:">
				        <el-radio-group v-model="formData.pushMode" style="line-height: 1;" @change="changePushmode">
				            <el-radio :label="1">立即推送</el-radio>
				            <el-radio :label="2">定时推送</el-radio>
				        </el-radio-group>
				    </el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8" v-if="formData.pushMode == 2 ">
					<el-form-item prop="pushTiming" label="定时推送时间:">
						<el-date-picker v-model="formData.pushTiming" type="datetime" placeholder="请输入定时推送时间"
						value-format="yyyy-MM-dd HH:mm:ss" size="medium"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="40">			    
				<el-col :xs="24" :sm="12" :xl="8">
				    <el-form-item prop="terminal" label="推送平台:">
				        <el-checkbox-group v-model="formData.terminal" style="line-height: 1;">
				            <el-checkbox :label="2">IOS</el-checkbox>
				            <el-checkbox :label="1">Android</el-checkbox>
				        </el-checkbox-group>
				    </el-form-item>
				</el-col>				
			</el-row>  
			<el-row :gutter="40">
				<el-col  :xs="24" :xl="16">
					<el-card  header="触达用户" class="box-card">
						<el-row :gutter="40" class="MB20">
							<el-col :span="24">
								<el-checkbox v-model="formData.touchCity" :true-label="1" :false-label="0">特定城市用户</el-checkbox>
								<el-select v-model="formData.cityCodeList" :filterable="true" :multiple="true" :clearable="true" placeholder="请选择">
								    <el-option-group v-for="item in cityOptions" :key="item.label" :label="item.label">
								        <el-option v-for="cld in item.children" :key="cld.value" :label="cld.label" :value="cld.value"></el-option>
								    </el-option-group>
								</el-select>
								<div>
								    <small class="from-tip"><span class="el-icon-warning"></span> 如需全网推送，请填写【全国】</small>
								</div>
							</el-col>							
						</el-row>
						<el-row class="MB20" :gutter="40">
							<el-col :span="24">
								<div>
									<el-checkbox v-model="formData.touchActivity" :true-label="1" :false-label="0">演出用户</el-checkbox>						
									<el-select
									    v-model="activityIdList"
									    value-key="value" 
									    :filterable="true" 
									    :remote="true"
									    :remote-method="remote"
										multiple
									    :loading="remoteLoading"
									    @change="touchActivityChange"
									    placeholder="请选择(填写ID搜索)"
									    >
									    <el-option v-for="item in remoteOptions" :key="item.value" :label="item.label" :value="item"></el-option>
									</el-select>
									<div>
									    <small class="from-tip"><span class="el-icon-warning"></span> 一次最多选择20个演出，将推送给演出的购票和收藏用户</small>
									</div>
								</div>
							</el-col>
						</el-row>
						<el-row class="MB20" :gutter="40">
							<el-col :span="24">
								<el-checkbox v-model="formData.touchCircle" :true-label="1" :false-label="0">按标签圈选用户</el-checkbox>						
								<MessageLabelAdduser ref="MessageLabelAdduser" :circleParam.sync="circleParam" :circleNum.sync="circleNum"></MessageLabelAdduser>
								<div v-if="this.circleNum > 0 " class="MT20 color-blue">共圈选到{{circleNum}}个用户，最多发送100W用户</div>
							</el-col>
						</el-row>
						<el-row :gutter="40" class="MB20">
							<el-col :span="24">								
									<el-checkbox v-model="formData.touchFans" :true-label="1" :false-label="0">艺人粉丝</el-checkbox>						
									<el-select 
										v-model="formData.artistIdList" 
										filterable 
										remote
										multiple
										placeholder="请输入B类用户名称"
										:remote-method="searchFansUser"							
										:loading="userLoading"
										@change="selectUser"
										size="medium">
										<el-option
											v-for="item in hostList"
											:key="item.id"
											:label="`[${$userType.get(item.userType)}]${item.name}`"
											:value="item.id">
										</el-option>
									</el-select>
							</el-col>
						</el-row>
						<el-row :gutter="40">
							<el-col :span="24">
								<el-checkbox v-model="formData.touchUser" :true-label="1" :false-label="0">手动指定用户</el-checkbox>
								<el-upload
								    ref="uploadFile"
								    drag
								    action
								    :http-request="upload"
								    :show-file-list="true"
								    :on-remove="onUploadRemove"
								    :disabled="uploadLoading"
								    accept=".xls, .xlsx"
								>
								        <i class="el-icon-upload"></i>
								        <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
								</el-upload>
								<el-button type="text" icon="el-icon-download" :loading="downloadTempLoading" @click="downloadTemp">点击下载模板</el-button>
							</el-col>
						</el-row>
					</el-card>
				</el-col>
			</el-row>			          
            <el-form-item class="MT20">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import {downloadFileTmp,uploadFileTmp,fetchAllCity,fetchUser} from '@/assets/js/commonApi.js';
import MessageLabelAdduser from '../components/MessageLabelAdduser';

export default {
  components: {ImageUpload,MessageLabelAdduser},
    data() {
        this.defaultFormData = {           
            title: null,          
            document: null,            
            // 1：演出 2：众筹 3：自定义 4：巡演
            type: 1,
            // 解析对象 演出ID、巡演ID、众筹ID
            pushObj: null,
            // 选填，点击上传图片框以后，需要支持截图，规格为1006px*660px，上传完成后展示图片缩略图，更多检测逻辑和错误提示，参考【秀动2.0管理后台和经营平台统一说明】中的规定
            imgPath: '',
            // 跳转链接：
            url: null,
            // 特定城市
            touchCity: 1,
            // 触达特定城市
            cityCodeList: [],
            // 手动指定用户
            touchUser: 0,
			//粉丝艺人
			touchFans:0,
			touchActivity:0,
			artistIdList:[],
			sponsorsIds:[],
            // 自定义用户文件key
            batchImportKey: null,
            // 巡演跳转规则
            rule: 1,
            // 推送平台
            terminal: [1, 2],
			userType:1,
			activityIdList:[],
			touchCircle:0,
			circleParam:null,
			pushMode:1
			
        }

        this.ukey = Date.now();

        return {
            visible: false,
            formData: {
                ...this.defaultFormData
            },
			redirect: this.$route.query.redirect || '',
            rules: {
                title: { required: true, message: "请填写推送名称", trigger: 'change'},
                document: { required: true, message: "请填写消息内容", trigger: 'change'},
                type: { required: true, message: "请选择推送对象", trigger: 'change'},
                pushObj: { required: true, message: "请选择解析对象", trigger: 'change'},
                rule: { required: true, message: "请选择巡演跳转规则", trigger: 'change'},
                terminal: { required: true, message: "请选择推送平台", trigger: 'change'},
				pushMode: { required: true, message: "请选择推送方式", trigger: 'change'},
				pushTiming:{ required: true, message: "请填写定时推送时间", trigger: 'change'}
            },
            remoteOptions: [],
            remoteLoading: false,
            cityOptions: [],
            uploadLoading: false,
            downloadTempLoading: false,
            submitLoading: false,			
			userLoading:false,
			hostList:[...this.defaultFormData.artistIdList],
			activityIdList:[],
			
			pageLoading:false,
			
			circleParam:null,
			circleNum:''
			
			
        };
    },
    watch:{
		
       'formData.type': function(n) {
           this.ukey++;
           // 1：演出 2：众筹 3：自定义 4：巡演
           switch (n) {
               case 1: //演出
                   this.formData.pushObj = null;
                   this.remoteOptions = [];
                   this.formData.touchActivity = 1;
                   this.formData.cityCodeList = [];
				   this.formData.artistIdList = [];
                   this.formData.touchUser = 0;
                   this.formData.batchImportKey = null;
                   this.$refs.uploadFile.clearFiles();
                   break;
                case 4: // 巡演
                   this.formData.pushObj = null;
                   this.remoteOptions = [];
                   this.formData.touchCity = 1;
                   this.formData.cityCodeList = [];
				   this.formData.artistIdList = [];
                   this.formData.touchUser = 0;
                   this.formData.batchImportKey = null;
                   this.$refs.uploadFile.clearFiles();
                   this.formData.rule = 1;
                   break;
                case 2: // 众筹
                   this.formData.pushObj = null;
                   this.remoteOptions = [];
                   this.formData.touchCity = 1;
                   this.formData.cityCodeList = [0];
				   this.formData.artistIdList = [];
                   this.formData.touchUser = 0;
                   this.formData.batchImportKey = null;
                   this.$refs.uploadFile.clearFiles();
                   break;
                case 3: // 自定义
                   this.formData.imgPath = '';
                   this.formData.url = null;
                   this.formData.touchCity = 1;
                   this.formData.cityCodeList = [0];
				   this.formData.artistIdList = [];
                   this.formData.touchUser = 0;
                   this.formData.batchImportKey = null;
                   this.$refs.uploadFile.clearFiles();
                   break;
           }

           this.$nextTick(() => {
                this.$refs['formData'].clearValidate('pushObj');
           });
       } 
    },
    created() {
        this.fetchCity();
    },
    methods: {
		// 搜索用户
		async searchUser(query,userType,obj){
		    if(query !== ""){
		        this.userLoading = true;
		        const res = await fetchUser({
		            queryValue:query,
		            userType:userType,
		        }).finally(() => {
		            this.userLoading = false;
		        });
		        
		        const { state, result } = res.data;
		        
		        if (state == 1 && result) {
		            const _result = [...result];
		            _result.map(v => {
		                v.key = v.id
		            })
		            this[obj] = _result;					
		        }
		    }
		},
		searchFansUser(query){
		    this.searchUser(query,-1,'hostList');			
		},
		//选择用户
		selectUser(e){
		    this.formData.artistIdList = e
		},
		changePushmode(e){
			if( e ===1 ){
				this.formData.pushTiming = ''
			}
		},
        // 获取城市
        async fetchCity() {
            const res = await fetchAllCity().catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });
            const { state , result } = res.data;
            if(state !== '1') {
                return ;
            }
            const cityOptions = (result || []).map(item => {
                return {
                    label: item.name, 
                    children: (item.cityList || []).map(({id, name}) => ({label: name, value: id}))
                }
            });
            cityOptions.unshift({label: '所有城市', children: [{label: '全国', value: 0}]});
            this.cityOptions = cityOptions;
        },
        pushObjChange() {
            const {type, pushObj} = this.formData;

            if((type === 1 || type === 4) && pushObj) {
                this.formData.cityCodeList = pushObj.cityCodeList;
            }
        },
		touchActivityChange(e){
			this.activityIdList = e			
			var _array = []
			this.activityIdList.forEach( item => {
			    _array.push(item.value)
			})
			_array = _array.join(',')
			this.formData.activityIdList = _array.split(',')
					
		},
		
        // 远程检索
        remote(q) {
            if (!q) {
                this.remoteOptions = [];
                return;
            }

            const {formData: {type}} = this;

            switch (type) {
                case 1:
                    this.remoteShow(q);
                    break;
                case 2:
                    this.remoteCrowd(q);
                    break;
                case 4:
                    this.remoteTouring(q);
                    break;
            }
        },
        // 演出
        async remoteShow(id) {
            this.remoteLoading = true;

            const res = await this.$request({
                url: '/msg/push/check/activity',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state , result } = res.data;

            if(state !== '1') {
                this.remoteOptions = [];
                return ;
            }

            const {name, cityCodeAndNameVo: {cityName, cityCode}} = result;

            this.remoteOptions = [{label: name, value: id, labelTips: `演出场地：${cityName}`, cityCodeList: [cityCode]}];
        },
        // 众筹
        async remoteCrowd(id) {
            this.remoteLoading = true;

            const res = await this.$request({
                url: '/msg/push/check/raise',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state , result } = res.data;

            if(state !== '1') {
                this.remoteOptions = [];
                return ;
            }

            const {name, userName} = result;

            this.remoteOptions = [{label: name, value: id, labelTips: `发起人：${userName}`}];
        },
        // 巡演
        async remoteTouring(id) {
            this.remoteLoading = true;

            const res = await this.$request({
                url: '/msg/push/check/tour',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.remoteLoading = false;
            });

            const { state , result } = res.data;

            if(state !== '1') {
                this.remoteOptions = [];
                return ;
            }

            const {name, cityCodeAndNameVos = []} = result;

            this.remoteOptions = [{
                label: name, 
                value: id, 
                labelTips: `巡演站次：${cityCodeAndNameVos.length}`, 
                cityCodeList: cityCodeAndNameVos.map(item => item.cityCode)
            }];
        },
        // 上传文件
        async upload({file}){
            const type = this.$utils.getFileType(file.name);

            if(type !== 'xls' && type !== 'xlsx') {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
                return Promise.reject();
            }

            this.uploadLoading = true;

            const formData = new FormData();
            formData.append('file', file);

            const res = await uploadFileTmp(formData).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.uploadLoading = false;
            });

            const{state, msg, result} = res.data;

            if (state !== '1') {
                this.$message.error(msg || '请求失败');
                return Promise.reject();
            }

            const path = result.url;

            return await this.setUpload(path);
        },
        // 设置上传文件数据
        async setUpload(path) {
            this.uploadLoading = true;

            const res = await this.$request({
                url: '/msg/push/import',
                method: 'post',
                params: {path}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.uploadLoading = false;
            });

            const { state, msg , result} = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return Promise.reject();
            }

            const {key} = result;

            this.formData.batchImportKey = key;
        },
        onUploadRemove() {
            this.formData.batchImportKey = null;
        },
        // 下载模板
        async downloadTemp() {
            this.downloadTempLoading = true;

            const res = await this.$request({
                url:'/msg/push/download',
                method: 'post',
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.downloadTempLoading = false;
            });

            const{state, msg, result} = res.data;

            if(state !== '1'){
                this.$message.error(msg || '下载失败');
                return ;
            }  

            await downloadFileTmp(result.url, '消息触达用户ID.xlsx');
        },
		//返回
		goBack() {
		    if(this.redirect){
		        this.$router.push({
		            path: this.redirect,
		        });
		    }else{
		        this.$router.go(-1);
		    }
		},
		
        // 表单提交  4116480200需求增加了演出去重的功能，所以这里写法不是最优，后面来优化
        submitForm() {
            this.$refs["formData"].validate(async (valid) => {
                if(!valid) {
                    return ;
                }

                const {type, pushObj, imgPath, url, touchActivity, touchCity, cityCodeList, touchUser,touchFans,touchCircle,circleParam,artistIdList,activityIdList,batchImportKey, rule, terminal, ...other} = this.formData;

				 
                if(touchCity === 0 && touchUser === 0 && touchFans === 0 && touchActivity === 0 && touchCircle === 0 ) {
                    return this.$message.error('请选择触达用户');
                }
				
				if(touchActivity === 1 && activityIdList.length === 0) {
				    return this.$message.error('请填写演出ID');
				}
				
				if(touchActivity === 1 && activityIdList.length > 20 ) {
				    return this.$message.error('一次性最多选择20个演出');
				}
                if(touchCity === 1 && cityCodeList.length === 0) {
                    return this.$message.error('请填写城市');
                }

                if(touchUser === 1 && !batchImportKey) {
                    return this.$message.error('请上传用户ID');
                }
				if(touchFans === 1 && artistIdList.length === 0 ) {
				    return this.$message.error('请填写艺人名称');
				}
				if(touchCircle === 1 && this.circleParam === null ) {
				    return this.$message.error('请先按标签圈选人群');
				}

                const {value: pushObjId} = pushObj || {};
				
				
				
                const formData = {
                    ...other, 
                    type,
                    pushObjId: type === 3 ? null : pushObjId,
                    imgPath: type === 3 ? imgPath : null,
                    url: type === 3 ? url : null,
                    //touchType,
                    cityCodeList,
					artistIdList,
					activityIdList,
                    batchImportKey,
                    rule: type === 4 ? rule : null,
                    terminal: terminal.length === 2 ? 0 : terminal[0],
					touchActivity,
					touchCity,
					touchFans,
					touchUser,
					circleParam: this.circleParam === null ? null : this.circleParam
                }

                this.submitLoading = true;
				
				if( this.formData.type == 1 ){
					this.$request({
					    url: "/msg/push/checkActivityMessage",
					    method: "POST",
					    params: {activityId:this.formData.pushObj.value },
					})
					    .then((res) => {
					        const { state, msg, result } = res.data;
							
							if(state === '-1') {
							    return  this.$message.error(msg || '请求失败');							   
							}
					        if (state == 1 && result == 0) {
								
								this.$request({
									url: '/msg/push/save',
									method: 'post',
									data: {...formData}
								})
									.then((res) => {
										const { state, msg, result } = res.data;
										if (state == 1) {
											this.$confirm('是否返回列表', '操作成功', {
											    type: 'success',
											    center: true,
											    confirmButtonText:'返回列表',
											    cancelButtonText:'留在当前页面',
											    closeOnClickModal: false
											}).then(() => {
											    this.goBack();
											}).catch(() => {										
											   window.location.reload()
											})
										} else {
											this.$message.error(msg || "操作失败,请重试");
											 this.submitLoading = false;
										}
									})
									.catch(() => {
										this.$message.error("操作失败,请重试");
									})
					           
					        } else {
					            const _html = "<div>\
					                <div style='font-weight:700'>该演出在24h内已经被推送过</div>\
					                <div>鉴于短时间内推送相同内容会<span class='color-danger'>导致用户关闭推送</span>，使推送内容无法触达粉丝，本次推送将<span class='color-danger'>不会对已收到相同推送的用户下发</span></div>\
									</div>"
					            this.$confirm(_html, '', {
					                dangerouslyUseHTMLString: true,
									confirmButtonText: '确定推送',
									cancelButtonText: '取消',
					            }).then(() => {
									
									
									this.$request({
										url: '/msg/push/save',
										method: 'post',
										data: {...formData}
									})
										.then((res) => {
											const { state, msg, result } = res.data;
											if (state == 1) {
												this.$confirm('是否返回列表', '操作成功', {
												    type: 'success',
												    center: true,
												    confirmButtonText:'返回列表',
												    cancelButtonText:'留在当前页面',
												    closeOnClickModal: false
												}).then(() => {
												    this.goBack();
												}).catch(() => {										
												   window.location.reload()
												})
											} else {
												this.$message.error(msg || "操作失败,请重试");
												this.submitLoading = false;
											}
										})
										.catch(() => {
											this.$message.error("操作失败,请重试");
										})
										
										
					                
					            }).catch(() => {
									this.submitLoading = false
					            })
					        }
					    })
					    .catch(() => {
					        this.$message.error("请求错误");
					    })
				}else{
					
					
					
					this.$request({
						url: '/msg/push/save',
						method: 'post',
						data: {...formData}
					})
						.then((res) => {
							const { state, msg, result } = res.data;
							if (state == 1) {
								this.$confirm('是否返回列表', '操作成功', {
								    type: 'success',
								    center: true,
								    confirmButtonText:'返回列表',
								    cancelButtonText:'留在当前页面',
								    closeOnClickModal: false
								}).then(() => {
								    this.goBack();
								}).catch(() => {										
								   window.location.reload()
								})
							} else {
								this.$message.error(msg || '请求失败');
								this.submitLoading = false;
							}
						})
						.catch(() => {
							this.$message.error("操作失败,请重试");
						})
						
						
					
				
				}
               
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.el-card{
    .el-col{
        line-height: 28px;
    }
}
::v-deep .strong{
	font-weight: bold;
}
</style>